import React, { memo } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { PhoneInputRedux, CustomInput } from "components";
import RadioButton from "components/radioButton";
import { trimMidSentenceNormalizer, trimNormalizer } from "validators";
import { maxPhoneLength15, phoneMinLength8 } from "validators/userValidators";
import {
	applyValidatorsIf,
	emailValid,
	normalizeAll,
	onlyAlphanumericAndSpecialCharacters,
	required,
} from "validators/validation";

import styles from "../formSections.module.scss";

let PrimaryContact = ({
	isLoading,
	isPrimaryContactTheSameLabel = "Is the same as the Owner 1?",
	isPrimaryContactTheSame = false,
	isPrimaryContactTheSameValue,
	isRequired = false,
	formName,
}) => {
	const isPrimaryContactNotTheSame = (_, allValues) => {
		if (allValues.primaryContactSection) {
			return (
				allValues.primaryContactSection.isPrimaryContactTheSame ===
					"false" && isRequired
			);
		} else {
			return allValues.isPrimaryContactTheSame === "false" && isRequired;
		}
	};

	const isDisabled = isPrimaryContactTheSameValue === "true";

	const requiredValidator = applyValidatorsIf(isPrimaryContactNotTheSame)(
		[required],
		[],
	);

	const emailValidator = applyValidatorsIf(isPrimaryContactNotTheSame)(
		[required, emailValid],
		[emailValid],
	);

	const phoneValidator = applyValidatorsIf(isPrimaryContactNotTheSame)(
		[required, phoneMinLength8, maxPhoneLength15],
		[phoneMinLength8, maxPhoneLength15],
	);

	return (
		<>
			<div className={styles.formSectionTitle}>
				<h3>Primary Contact</h3>
			</div>
			{isPrimaryContactTheSame ? (
				<Row>
					<Col md={12}>
						<div className={styles.addressTitle}>
							{isPrimaryContactTheSameLabel}
						</div>
						<div className={`${styles.wrappRadio} ${`mb-2`}`}>
							<Field
								component={RadioButton}
								value="true"
								name="isPrimaryContactTheSame"
								className={styles.radioButton}
								id="isPrimaryContactTheSame"
								blurLoading={isLoading}
								type="radio"
								label="Yes"
							/>
							<Field
								component={RadioButton}
								value="false"
								name="isPrimaryContactTheSame"
								className={styles.radioButton}
								id="isNotPrimaryContactTheSame"
								blurLoading={isLoading}
								type="radio"
								label="No"
							/>
						</div>
					</Col>
				</Row>
			) : null}
			<Row className="mt-3">
				<Col md={5}>
					<Field
						component={CustomInput}
						validate={requiredValidator}
						label="First Name"
						name="firstName"
						normalizeOnBlur={trimNormalizer}
						normalize={normalizeAll([
							onlyAlphanumericAndSpecialCharacters,
							trimMidSentenceNormalizer,
						])}
						blurLoading={isLoading}
						disabled={isDisabled}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<Field
						component={CustomInput}
						validate={requiredValidator}
						label="Last Name"
						name="lastName"
						normalizeOnBlur={trimNormalizer}
						normalize={normalizeAll([
							onlyAlphanumericAndSpecialCharacters,
							trimMidSentenceNormalizer,
						])}
						blurLoading={isLoading}
						disabled={isDisabled}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={5}>
					<Field
						component={PhoneInputRedux}
						label="Contact Phone"
						name="phone"
						isRequired={!isPrimaryContactNotTheSame}
						validate={phoneValidator}
						disabled={isDisabled}
						formName={formName}
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<Field
						component={CustomInput}
						validate={emailValidator}
						label="Email"
						name="email"
						normalize={normalizeAll([trimMidSentenceNormalizer])}
						normalizeOnBlur={trimNormalizer}
						blurLoading={isLoading}
						disabled={isDisabled}
					/>
				</Col>
			</Row>
			<Row>
				<Col md={5}>
					<Field
						component={CustomInput}
						validate={requiredValidator}
						label="Title / Position"
						name="titlePosition"
						normalizeOnBlur={trimNormalizer}
						normalize={normalizeAll([
							onlyAlphanumericAndSpecialCharacters,
							trimMidSentenceNormalizer,
						])}
						blurLoading={isLoading}
						disabled={isDisabled}
					/>
				</Col>
			</Row>
		</>
	);
};

const component = memo(PrimaryContact);
export { component as PrimaryContact };
